import { AlsBase, getDefaultAlsBase } from './AlsBase'


export interface AlsUser extends AlsBase {    
    usrEmail: string    
}

export const getDefaultAlsUser = (commit:boolean=true):AlsUser => {     
    return {
        ...getDefaultAlsBase(commit),
        usrEmail:''
    }
}

export const cleanAlsUser = (filter:AlsUser) => {
    if(!filter) return    
    if(!filter.id) delete filter.id
}
